import React, { useState } from "react";
import "./AdmissionForm.css";
import { Helmet } from "react-helmet";
import { db } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export default function AdmissionForm() {
  const [formData, setFormData] = useState({
    name: "",
    fatherName: "",
    guardianPhone: "",
    phone: "",
    email: "",
    cnic: "",
    dob: "",
    city: "",
    address: "",
    education: "",
    course: "",
    mode: "",
    timing: "",
    experience: "",
    goal: "",
    reference: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // ✅ Save to Firebase
      await addDoc(collection(db, "admissions"), {
        ...formData,
        createdAt: serverTimestamp()
      });

      // ✅ Professional WhatsApp Message
      const text = `*🎓 NEW ADMISSION - SAMSOFTIX*%0A%0A
👤 Name: ${formData.name}%0A
👨 Father: ${formData.fatherName}%0A
📱 Phone: ${formData.phone}%0A
📞 Guardian: ${formData.guardianPhone}%0A
📧 Email: ${formData.email}%0A
🆔 CNIC: ${formData.cnic}%0A
🎂 DOB: ${formData.dob}%0A
🏙 City: ${formData.city}%0A
🏠 Address: ${formData.address}%0A%0A
🎓 Education: ${formData.education}%0A
📚 Course: ${formData.course}%0A
💻 Mode: ${formData.mode}%0A
⏰ Timing: ${formData.timing}%0A
💡 Experience: ${formData.experience}%0A
🎯 Goal: ${formData.goal}%0A
🔗 Reference: ${formData.reference}%0A%0A
📝 Message: ${formData.message}`;

      window.open(`https://wa.me/923320472184?text=${text}`, "_blank");

      setSuccess(true);

      setFormData({
        name: "",
        fatherName: "",
        guardianPhone: "",
        phone: "",
        email: "",
        cnic: "",
        dob: "",
        city: "",
        address: "",
        education: "",
        course: "",
        mode: "",
        timing: "",
        experience: "",
        goal: "",
        reference: "",
        message: ""
      });

    } catch (error) {
      console.error(error);
      alert("Error submitting form. Try again.");
    }

    setLoading(false);
  };

  return (
    <div className="form-page">

      <Helmet>
        <title>Admission Form | SamSoftix Institute</title>
      </Helmet>

      <div className="form-container">

        <h1>🎓 SamSoftix Admission Form</h1>
        <p>Fill complete details for enrollment</p>

        {success && (
          <p style={{ color: "green", textAlign: "center" }}>
            ✅ Application submitted successfully!
          </p>
        )}

        <form onSubmit={handleSubmit}>

          {/* PERSONAL */}
          <h3>👤 Personal Details</h3>

          <input name="name" placeholder="Full Name" onChange={handleChange} required />
          <input name="fatherName" placeholder="Father Name" onChange={handleChange} required />
          <input name="phone" placeholder="Student Phone" onChange={handleChange} required />
          <input name="guardianPhone" placeholder="Guardian Phone" onChange={handleChange} required />

          <input name="email" placeholder="Email (optional)" onChange={handleChange} />
          <input name="cnic" placeholder="CNIC (optional)" onChange={handleChange} />
          <input name="dob" type="date" onChange={handleChange} />
          <input name="city" placeholder="City" onChange={handleChange} required />
          <input name="address" placeholder="Full Address" onChange={handleChange} />

          {/* EDUCATION */}
          <h3>🎓 Education</h3>
          <select name="education" onChange={handleChange} required>
            <option value="">Select Education</option>
            <option>Matric</option>
            <option>Intermediate</option>
            <option>Graduate</option>
            <option>Other</option>
          </select>

          {/* COURSE */}
          <h3>📚 Course Selection</h3>
          <select name="course" onChange={handleChange} required>
            <option value="">Select Course</option>
            <option>Web Development</option>
            <option>UI/UX Design</option>
            <option>Graphic Designing</option>
            <option>Office Management</option>
            <option>Freelancing</option>
            <option>Digital Marketing</option>
            <option>AI & ChatGPT</option>
            <option>MS Office</option>
          </select>

          {/* MODE */}
          <select name="mode" onChange={handleChange} required>
            <option value="">Class Mode</option>
            <option>Online</option>
            <option>Physical</option>
          </select>

          {/* TIMING */}
          <select name="timing" onChange={handleChange} required>
            <option value="">Preferred Timing</option>
            <option>Morning</option>
            <option>Afternoon</option>
            <option>Evening</option>
          </select>

          {/* EXPERIENCE */}
          <select name="experience" onChange={handleChange}>
            <option value="">Experience Level</option>
            <option>Beginner</option>
            <option>Intermediate</option>
            <option>No Experience</option>
          </select>

          {/* GOAL */}
          <input name="goal" placeholder="Your Learning Goal (e.g. freelancing, job, business)" onChange={handleChange} />

          {/* REFERENCE */}
          <input name="reference" placeholder="How did you hear about SamSoftix?" onChange={handleChange} />

          {/* MESSAGE */}
          <textarea name="message" placeholder="Any additional message" onChange={handleChange} />

          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit Application"}
          </button>

        </form>

        <p className="note">
          📞 Our team will contact you within 24 hours for confirmation.
        </p>

      </div>
    </div>
  );
}